/**
 * Advances a "keep the last truthy value" ref across renders. For a combined-loading-value
 * hook whose result can go momentarily falsy on a background reload (e.g. a new Firestore
 * subscription briefly resolving to `undefined`), calling this on every render lets a
 * component keep showing the last real value through that flicker instead of unmounting
 * whatever's gated on it — see ParticipantDialog.tsx's `v`/`liveV` for the motivating bug
 * (assigning a first-time supporting actor briefly unmounted the whole dialog).
 *
 * Pulled out as a plain function (not a hook) so the "which value wins" decision is
 * testable without a React renderer — the caller still owns the actual `useRef`.
 */
export const advanceStickyValue = <T>(
  ref: { current: T | null | undefined },
  liveValue: T | null | undefined
): T | null | undefined => {
  if (liveValue) {
    ref.current = liveValue;
  }
  return liveValue || ref.current;
};
